//import axios from 'axios'

export function eanCD(barcode) 
    {
      var cd = 0
      for (var i = 0; i < 11 ; i++)
      {  
        cd = cd + parseInt(barcode.substr(i,1))
        cd = cd + parseInt(barcode.substr(i + 1, 1)) * 3
        /* step2 */
        i++
      }
      cd = (10 - cd % 10) % 10
      return cd
    }

export function createEAN_SALE(saleId)  
    { 
      const codifica = '500000000000'
      const pad      = '000000'
      
      var barcode    = codifica.substring(0,12-saleId.toString().length) + saleId.toString()
      
      const cd       = eanCD(barcode)
      return barcode + cd

    }
    
    export function createEAN_PROMO(couponId)  
    { 
      const codifica = '900000000000'
      const pad      = '000000'
      
      var barcode    = codifica.substring(0,12-couponId.toString().length) + couponId.toString()
      
      const cd       = eanCD(barcode)
      return barcode + cd

    }
 
  export function createEAN_COUPON(couponId)  
    { 
      const codifica = '600000000000'
      const pad      = '000000'
      
      var barcode    = codifica.substring(0,12-couponId.toString().length) + couponId.toString()
      
      const cd       = eanCD(barcode)
      return barcode + cd

    }



export function createEAN13(productId,counter)  
    { 
      const codifica = '3000000'
      const pad      = '00000'
      
      var barcode    = codifica.substring(0,7-productId.toString().length) + productId.toString()
      barcode        += pad.substring(0,5-counter.toString().length) + counter.toString()
      const cd       = eanCD(barcode)
      return barcode + cd

    }

export function setCategory(items)
    {
      var obj          = {}
      var optionGroups = []
      items.forEach(item=>{
        if(!item.parentId)
        {
          obj[item.category]=[]
        }
      })
      optionGroups = Object.assign(obj)
      var elem     = ''
      let category_it = ''
      items.forEach(item=>{
        if(!item.parentId)
        {
          elem    = item.category
          var arr = items.filter(el => el.parentId == item.categoryId)
          arr.sort(sortCat)
          arr.forEach(i=>{
                category_it = ''
                if(i.category_it)
                {
                  category_it =  ' -> ' +  i.category_it
                }
                optionGroups[elem].push({'text':i.category  + category_it,'value':i.categoryId})  
          })
              
        }
        
      })
     
			return optionGroups
		}
    export function sortCat(a,b)
    {
      
      // Use toUpperCase() to ignore character casing
      const bandA = a.category.toUpperCase();
      const bandB = b.category.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
          comparison = 1;
        } else if (bandA < bandB) {
          comparison = -1;
         }
          return comparison;
    }	
    
    export function setFmtDate1(data)
    {      
      const dd      = data.substr(8,2)
      const mm      = data.substr(5,2)
      const yyyy    = data.substr(0,4)
      const newDate = dd + '/' + mm + '/' + yyyy 
      return `${newDate}`
     
    }
    export function setFmtDate2(data)
    {      
      const dd      = data.substr(0,2)
      const mm      = data.substr(3,2)
      const yyyy    = data.substr(6,4)                        
      const newDate = yyyy + '-' + mm + '-' + dd             
      return `${newDate}`      
    }
    export function setFmtDate3(data)
    {      
      const dd      = data.substr(6,2)
      const mm      = data.substr(4,2)
      const yyyy    = data.substr(0,4)
      const newDate = dd +  mm +  yyyy 
      return `${newDate}`
     
    }
    export function setFmtDate4(data)
    { 
      const str = '0'
      const index1  = data.indexOf('/')     
      const index2  = data.lastIndexOf("/")
      
      const dd      = data.substring(0, index1) 

      const mm      = data.substring(index1 + 1,index2)
      
      const yyyy    = data.substr(index2 + 1,4)
      const newDate = str.repeat(2 - dd.length) + dd + str.repeat(2-mm.length) +  mm +  yyyy 
      
      return `${newDate}`
     
    }




